// extracted by css-extract-rspack-plugin
export default {"embedModalHeader":"egGav"};